import Component from './component.vue';
import Props from './props';
import Script from './script';

export * from './enums';
export {
  Props,
  Script,
};
export default Component;



// WEBPACK FOOTER //
// ./src/components/calendar/detail/index.ts